import { render } from "./SimpleNoteCreateInfoCard.vue?vue&type=template&id=de87bd02&scoped=true"
import script from "./SimpleNoteCreateInfoCard.vue?vue&type=script&lang=js"
export * from "./SimpleNoteCreateInfoCard.vue?vue&type=script&lang=js"

import "./SimpleNoteCreateInfoCard.vue?vue&type=style&index=0&id=de87bd02&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de87bd02"]])

export default __exports__